module.exports = __webpack_public_path__ + "source/img/mtuijian.55fca6ca.png";